export const reportingQueryKeys = {
  all: ['reporting'] as const,
  aiSummaryStats: () => [...reportingQueryKeys.all, 'genesys-call-summary-stats'] as const,
};
